import { pushEvent } from "./helpers.js";
import { getPageType } from "../../utils/utils/get-page-type.js";
const pushPageTypeToDataLayer = (seoPageType, pageName) => {
  const name = pageName?.replace(/-/g, " ").toLowerCase();
  const pageType = getPageType(seoPageType);
  const searchParams = new URLSearchParams(window.location.search);
  if (name === "pagenotfound" || name?.includes("checkout") || // Event for checkout is handled in CheckoutRoot.tsx component because the seoPageType doesn't have currently 'checkout' option
  name?.includes("product detail page") || //Event for PDP's is handled in ProductDetail.tsx component because its not possible to cofigure seo for PDP's in BR cms
  pageType === "product listing" && searchParams && searchParams.toString() !== "" || // Event for PLP's is handled in ConnectedProductListing.tsx component if there is pre applied filters.
  seoPageType === void 0) {
    return;
  }
  pushEvent({
    event: "page_data_loaded",
    page: {
      unixTimestamp: Math.floor(Date.now() / 1e3),
      type: pageType
    }
  });
};
export {
  pushPageTypeToDataLayer
};
//# sourceMappingURL=pageType.js.map
